module.exports = __webpack_public_path__ + "img/icon-remain-clock.e8f3a41c.png";